import { Text, TextProps } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';

export function HelperText(props: TextProps) {
    return (
        <>
            <Helper>Helper</Helper>
            <StyledText {...props}>{props.children}</StyledText>
        </>
    );
}

const StyledText = styled(Text)`
    color: var(--chakra-colors-text-secondary);
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0%;
`;

const Helper = styled(Text)`
    color: var(--chakra-colors-text-secondary);
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.5px;
`;
